import { makeAutoObservable } from 'mobx';
import { SceneItem } from '../../components/roomModelController/types';
import { roomModelControllerStore } from '../../components/roomModelController/roomModelController.store';
import { unityProviderStore } from '../../components/UnityLoader/unity.provider.store';

class SendMessage {
  selected: SceneItem | null = null;

  sendMessage: Function;

  unitySound = true;

  constructor() {
    makeAutoObservable(this);
  }

  setSendMessage = (func: Function) => {
    this.sendMessage = func;
  };

  deleteSelectedObject = () => {
    this.sendMessage('ReactManager', 'DeleteSelected');
    roomModelControllerStore.removeById(this.selected?.id || 0);
    this.selected = null;
  };

  deselectObject = () => {
    this.selected = null;
  };

  moveToFront = () => {
    sendMessageStore.sendMessage('ReactManager', 'RequestNearestTransform');
    const avatarPosition = JSON.parse(unityProviderStore.avatarPosition);
    const size = sendMessageStore.selected?.position.size || (1 as number);
    const sendData = JSON.stringify({
      ...avatarPosition,
      positionY: avatarPosition.positionY + size,
      size: size,
    });
    this.setTransformChanging(true);
    sendMessageStore.sendMessage(
      'TransformEditJsEventsHandler',
      'SetTransform',
      sendData,
    );
    this.setTransformChanging(false);
  };

  selectModel = (selectedModel: SceneItem) => {
    try {
      this.sendMessage(
        'ReactManager',
        'SelectModelFromWeb',
        `${selectedModel.id}`,
      );
      this.selected = selectedModel;
    } catch (error) {
      console.log('Error selecting model:', error);
    }
  };

  setSelectedModelById = (id: any) => {
    this.selected = roomModelControllerStore.roomObjects.find(
      (elem: any) => elem.id === id,
    ) as SceneItem;
  };

  lockKeyboardInput = () => {
    if (this.sendMessage) {
      this.sendMessage('ReactManager', 'LockKeyboardInput', 'false');
    }
  };

  setUnitySound = (status: boolean) => {
    this.sendMessage('ReactManager', 'EnableSound', `${status}`);
    this.unitySound = status;
  };

  unLockKeyboardInput = () => {
    if (this.sendMessage) {
      this.sendMessage('ReactManager', 'LockKeyboardInput', 'true');
    }
  };

  showEmotions = (str: string) => {
    this.sendMessage('ReactManager', 'ShowEmotions', str);
  };

  changeMicById = (id: number, state: boolean) => {
    this.sendMessage(
      'ReactManager',
      'SetOtherUserMicrophoneState',
      JSON.stringify({
        id,
        mic: state,
      }),
    );
  };

  setTransformChanging = (status: boolean) => {
    this.sendMessage(
      'TransformEditJsEventsHandler',
      'SetIsChanging',
      `${status}`,
    );
  };
}
export const sendMessageStore = new SendMessage();
